export const showTokenInfoDialog = !!localStorage.getItem(
  'showTokenInfoDialog',
);

export const showSwapAddress = true;
